module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing"
  }, [_c('div', [_c('div', {
    staticClass: "landing-intro"
  }, [_c('img', {
    staticClass: "landing-img",
    style: ({
      color: _vm.theme.accent
    }),
    attrs: {
      "src": require("../assets/traian-dorz.jpg"),
      "alt": "Traian Dorz"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "landing__header",
    style: ({
      color: _vm.theme.accent
    })
  }, [_c('div', [_vm._v("Slăvit")]), _vm._v(" "), _c('div', [_vm._v("să fie")]), _vm._v(" "), _c('div', [_vm._v("Domnul")])])]), _vm._v(" "), _c('div', {
    staticClass: "landing-info"
  }, [_c('p', {
    staticClass: "landing-text"
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    style: ({
      color: _vm.listButtonHovered ? _vm.theme.background : _vm.theme.accent,
      backgroundColor: _vm.listButtonHovered ? _vm.theme.accent : ''
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebarLeft,
      "mouseenter": function($event) {
        _vm.listButtonHovered = true
      },
      "mouseleave": function($event) {
        _vm.listButtonHovered = false
      }
    }
  }, [_vm._v("\n        Cuprins\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    style: ({
      color: _vm.searchButtonHovered ? _vm.theme.background : _vm.theme.accent,
      backgroundColor: _vm.searchButtonHovered ? _vm.theme.accent : ''
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebarRight,
      "mouseenter": function($event) {
        _vm.searchButtonHovered = true
      },
      "mouseleave": function($event) {
        _vm.searchButtonHovered = false
      }
    }
  }, [_vm._v("\n        Căutare\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-897b8bb0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Landing.vue
// module id = 133
// module chunks = 1